/** @format */

import * as Yup from 'yup'

export const createResidentTypeSchema = Yup.object().shape({
  title: Yup.string()
    .trim()
    .required('Resident type is required')
    .max(50, 'Resident type cannot exceed 50 characters'),
  price: Yup.number()
    .typeError('Levy fee must be a valid number')
    .required('Levy fee is required')
    .min(0, 'Levy fee must be at least 0')
    .max(1000000, 'Levy fee cannot exceed 1,000,000'),
  description: Yup.string()
    .trim()
    .required('Description is required')
    .max(500, 'Description cannot exceed 500 characters'),
})
